import React from 'react'
import Add_Money from './add-money/Add_Money'
import Subscription_Plan from './subscription-plan/Subscription_Plan'
import Wallet_History from './wallet-history/Wallet_History'

function Wallet() {
  return (
<>
<Add_Money/>
<Subscription_Plan/>
<Wallet_History/>
</>
  )
}

export default Wallet